import { render, staticRenderFns } from "./ScrollContainer.vue?vue&type=template&id=34aed6b0&"
import script from "./ScrollContainer.vue?vue&type=script&lang=js&"
export * from "./ScrollContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports